import { useAppSelector } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { formStore, updateForm } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../redux/store';
import { UpdateModalProps } from './update-modal.component';

export const useUpdateModal = <T extends object, S extends object>(props: UpdateModalProps<T, S>) => {
    const { closeTopModal } = useModals();
    const dispatch = useAppDispatch();
    const [value, setValue] = useState<S>({} as S);
    const [formId] = useState(() => props.formId ?? crypto.randomUUID());
    const form = useAppSelector(useSelector, formStore);
    const formValues = useMemo(() => {
        const f = form[formId];
        if (!f) return {};
        return f.value;
    }, [form, formId]);

    useEffect(() => {
        if (!props.values || !form) return;
        dispatch(updateForm({ formId: formId, value: props.values }));
    }, [props.values, formId]);

    return {
        closeTopModal,
        value,
        setValue,
        formId,
        form,
        formValues
    };
};
